import {
  FETCH_TENANT_SUBSCRIPTION,
  SET_TENANT_SUBSCRIPTION,
  FETCH_CUSTOMER_SUBSCRIPTION,
  SET_CUSTOMER_SUBSCRIPTION,
  SET_CUSTOMER_SUBSCRIPTION_IS_LOADING,
  FETCH_STRIPE_CUSTOMER_DETAILS,
  SET_STRIPE_CUSTOMER_DETAILS,
  FETCH_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
  SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
  SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING,
  SET_SELECTED_SUBSCRIPTION,
  SET_SUBSCRIPTION_IS_LOADING,
} from "redux/constants/portal";

export const fetchTenantSubscription = (tenant_id) => ({
  type: FETCH_TENANT_SUBSCRIPTION,
  payload: { tenant_id },
});

export const setTenantSubscription = (payload) => ({
  type: SET_TENANT_SUBSCRIPTION,
  payload,
});

export const fetchCustomerSubscription = (customer_id) => ({
  type: FETCH_CUSTOMER_SUBSCRIPTION,
  payload: { customer_id },
});

export const setCustomerSubscription = (payload) => ({
  type: SET_CUSTOMER_SUBSCRIPTION,
  payload,
});

export const setCustomerSubscriptionIsLoading = (payload) => ({
  type: SET_CUSTOMER_SUBSCRIPTION_IS_LOADING,
  payload,
});

export const fetchStripeCustomerDetails = (customer_id) => ({
  type: FETCH_STRIPE_CUSTOMER_DETAILS,
  payload: { customer_id },
});

export const setStripeCustomerDetails = (payload) => ({
  type: SET_STRIPE_CUSTOMER_DETAILS,
  payload,
});

export const setIsStripeCustomerDetailsLoading = (payload) => ({
  type: SET_IS_STRIPE_CUSTOMER_DETAILS_LOADING,
  payload,
});

export const fetchNumberOfRemainingActiveFlowsAndExecutions = (tenant_id) => ({
  type: FETCH_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
  payload: { tenant_id },
});

export const setNumberOfRemainingActiveFlowsAndExecutions = (payload) => ({
  type: SET_NUMBER_OF_REMAINING_ACTIVE_FLOWS_AND_EXECUTIONS,
  payload,
});

export const setSelectedSubscription = (payload) => ({
  type: SET_SELECTED_SUBSCRIPTION,
  payload,
});

export const setSubscriptionIsLoading = (payload) => ({
  type: SET_SUBSCRIPTION_IS_LOADING,
  payload,
});
